import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateScreenTitle } from "../../../LayoutContainers/AppLayout/redux/AppSlice";
import AppService from "../../../Configurations/Appservice";
import PaymentItem from "./Panels/PaymentItem";
import uuid from "react-uuid";

const PendingPartnerPayments = () => {
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);

  useEffect(() => {
    dispatch(updateScreenTitle("Pending Payment"));
    return () => dispatch(updateScreenTitle(""));
  });

  useEffect(() => {
    AppService.get("v2/partner-payment-transactions/partner/pending-approval")
      .then((response) => {
        const data = response?.data || response;
        setItems(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        setItems([]);
      })
      .finally(() => {});
  }, []);

  const _onApprove = (item) => {
    let itemsCopy = items;
    itemsCopy = itemsCopy.filter((it) => it.id !== item.id);
    setItems(itemsCopy);
  };

  return (
    <Box>
      {items.map((item, index) => (
        <PaymentItem key={uuid()} item={item} onApprove={_onApprove} />
      ))}
    </Box>
  );
};

export default PendingPartnerPayments;
